var Dictionary = /** @class */ (function () {
    function Dictionary() {
        this.values = {};
    }
    Dictionary.prototype.add = function (key, value) {
        if (!key)
            return;
        this.values[key] = value;
    };
    Dictionary.prototype.get = function (key) {
        if (!key)
            return null;
        if (Object.prototype.hasOwnProperty.call(this.values, key)) {
            return this.values[key];
        }
    };
    Dictionary.prototype.remove = function (key) {
        if (!key)
            return;
        if (Object.prototype.hasOwnProperty.call(this.values, key)) {
            delete this.values[key];
        }
    };
    Dictionary.prototype.clear = function () {
        for (var key in this.values) {
            delete this.values[key];
        }
    };
    return Dictionary;
}());
export { Dictionary };
